import checkIsVariantShownInQuery from './checkIsVariantShownInQuery';

export default function checkIsVariantVisible(variant = {}, query = {}) {
  if (variant.hidden) {
    const isVariantShownInQuery = checkIsVariantShownInQuery(variant.reference, query);

    if (isVariantShownInQuery) return true;

    return false;
  }

  return true;
}
